import * as angular from "angular";
import {ApiConfig} from "../../commons/models/api-config.model";

export class FulfillmentRequestsService {

  /* @ngInject */
  constructor(private FulfillmentAPI, private $fulfillment, private splitService, private $http, private apiConfig: ApiConfig) {
  }

  getFulfillment(fulfillmentId, expand) {
    const api = this.FulfillmentAPI.actions.getFulfillment;
    return this.$$call(api, {expand: expand}, {}, {id: fulfillmentId});
  }

  getSteps(fulfillmentId) {
    const api = this.FulfillmentAPI.actions.getSteps;
    return this.$$call(api, {}, {}, {id: fulfillmentId});
  }

  getRelations(fulfillmentId, stepIds) {
    const api = this.FulfillmentAPI.actions.getRelations;
    return this.$$call(api, {}, stepIds, {id: fulfillmentId});
  }

  splitStep(fulfillmentId, stepId, payload) {
    const api = this.FulfillmentAPI.actions.splitStep;
    return this.$$call(api, {}, payload, {id: fulfillmentId, stepId: stepId});
  }

  getStepDispatchOption(fulfillmentId, stepId, notBefore, notAfter, suppliers) {
    const api = this.FulfillmentAPI.actions.getStepDispatchOption;
    return this.$$call(api, {notBefore: notBefore, notAfter: notAfter, suppliers: suppliers}, {}, {
      id: fulfillmentId,
      stepId: stepId
    });
  }

  dispatchStep(fulfillmentId, stepId, payload) {
    const api = this.FulfillmentAPI.actions.dispatchStep;
    return this.$$call(api, {}, payload, {id: fulfillmentId, stepId: stepId});
  }

  // getStepDispatchTimeRanges(fulfillmentId, stepId, notBefore, notAfter, dispatchType?, providerType?, payload?, quoteType?, expandSettings?) {
  //   const api = this.FulfillmentAPI.actions.getStepDispatchTimeRanges;
  //   return this.$$call(api, {
  //     notBefore: notBefore,
  //     notAfter: notAfter,
  //     dispatchType: dispatchType,
  //     providerType: providerType,
  //     internalQuoteType: quoteType,
  //     expandSettings: expandSettings,
  //     zoneId: this.splitService.getTimeZone()
  //   }, payload || {}, {
  //     fulfillmentId: fulfillmentId,
  //     stepId: stepId
  //   });
  // }

  getStepDispatchTimeRanges(fulfillmentId, stepId, notBefore, notAfter, dispatchType, providerType, payload, quoteType, expandSettings, cancelToken) {
    return this.$http({
      method: 'POST',
      url: this.apiConfig.baseUrl + `/fulfillment/${fulfillmentId}/step/${stepId}/options`,
      params: {
        notBefore,
        notAfter,
        dispatchType,
        providerType,
        quoteType,
        expandSettings,
        siteId: this.splitService.getSiteId(),
        zoneId: this.splitService.getTimeZone()
      },
      data: payload,
      timeout: cancelToken
    }).then(response => response.data);
  };

  getFulfillmentsByPage(page, size, filter) {
    if (!filter) {
      filter = {};
    }
    const api = this.FulfillmentAPI.actions.getFulfillmentsByPage;
    return this.$$call(api, {page: page, size: size}, filter, {});
  }

  getFulfillmentsTotals(filter) {
    if (!filter) {
      filter = {};
    }
    const api = this.FulfillmentAPI.actions.getTotals;
    return this.$$call(api, {}, filter, {});
  }

  bulkDispatch(payload) {
    const api = this.FulfillmentAPI.actions.bulkDispatch;
    return this.$$call(api, {}, payload, {});
  }

  exportFulfillmentSteps(payload, exportType, zoneId) {
    const api = this.FulfillmentAPI.actions.exportFulfillmentSteps;
    return this.$$call(api, {type: exportType, zoneId: zoneId}, payload, {});
  }

  getFulfillmentStepsPrice(fulfillmentId, stepIds) {
    const api = this.FulfillmentAPI.actions.getFulfillmentStepsPrice;
    return this.$$call(api, {stepId: stepIds}, {}, {fulfillmentId: fulfillmentId});
  }

  editFulfillmentStepsPriceFactor(fulfillmentId, stepsPriceFactor) {
    const api = this.FulfillmentAPI.actions.updateFulfillmentStepsPriceFactor;
    return this.$$call(api, {}, stepsPriceFactor, {fulfillmentId: fulfillmentId});
  }

  getFulfillmentStepDefaultBranches(fulfillmentId, stepId) {
    const api = this.FulfillmentAPI.actions.getFulfillmentStepDefaultBranches;
    return this.$$call(api, {}, {}, {fulfillmentId: fulfillmentId, stepId: stepId});
  }

  splitStepPackages(fulfillmentId, stepId, payload) {
    const api = this.FulfillmentAPI.actions.splitStepPackages;
    return this.$$call(api, {}, payload, {fulfillmentId: fulfillmentId, stepId: stepId});
  }

  getStepAttemptInfo(fulfillmentId: string, stepId: string, referenceId: string, fulfillmentSubType: string) {
    const api = this.FulfillmentAPI.actions.getStepAttemptInfo;
    return this.$$call(api, {referenceId: referenceId, type: fulfillmentSubType}, {}, {
      fulfillmentId: fulfillmentId,
      stepId: stepId
    });
  }

  cancelStep(fulfillmentId, stepId, cancelReason?) {
    const api = this.FulfillmentAPI.actions.cancelStep;
    return this.$$call(api, {}, cancelReason, {fulfillmentId: fulfillmentId, stepId: stepId});
  }

  onForceCompleteLine(fulfillmentId, fulfillmentLineId) {
    const api = this.FulfillmentAPI.actions.forceCompleteLine;
    return this.$$call(api, {lineId: fulfillmentLineId}, {}, {fulfillmentId: fulfillmentId});
  }

  restoreFulfillment(fulfillmentId: string, copyStepTemplateId?: boolean) {
    const api = this.FulfillmentAPI.actions.restoreFulfillments;
    return this.$$call(api, {copyStepTemplateId: copyStepTemplateId}, {}, {fulfillmentId: fulfillmentId});
  }

  bulkRestoreFulfillments(payload, copyStepTemplateId?: boolean) {
    const api = this.FulfillmentAPI.actions.bulkRestoreFulfillments;
    return this.$$call(api, {copyStepTemplateId: copyStepTemplateId}, payload, {});
  }

  // ******************************
  //        Private methods
  // ******************************

  $$call(_apiCall, _params, _data, _options) {
    return this.$fulfillment().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .service('fulfillmentRequestsService', FulfillmentRequestsService);
